// The server writes each public page's <title> with the words people type into
// search (FaceShot-ChopShop-web/lib/page-meta.js). Google reads the title after
// the app has run, so every page that set its own in-app title threw those words
// away: on 2026-10-27 Google listed /canvas as "Bring your music's cover art to
// life in Living Cover." instead of "Spotify Canvas maker and animated album
// cover". So on the page the server answered for, the server's title stands;
// once the visitor moves to another page inside the app, that page's own title
// is used. main.tsx imports this first, before any page loads, so the title and
// path read here are the ones the server sent.

const norm = (path: string) => path.replace(/\/+$/, '') || '/';

const BOOT_PATH = norm(window.location.pathname);
const BOOT_TITLE = document.title;

// The server sets a canonical only on a page it wrote a title for; a private or
// unknown path keeps the home page's canonical and so keeps the page's own title.
const SERVER_TITLED = (() => {
  const href = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
  if (!href || !BOOT_TITLE) return false;
  try {
    return norm(new URL(href, window.location.origin).pathname) === BOOT_PATH;
  } catch {
    return false;
  }
})();

export function pageTitle(own: string): string {
  return SERVER_TITLED && norm(window.location.pathname) === BOOT_PATH ? BOOT_TITLE : own;
}
